import { authFetch, sapFetch } from "../../api";

export const getUserPrefrences = async (payload) => {
  try {
    const response = await authFetch(
      `profile/show-preference`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload), 
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error fetching show-preference:", err.message);
    throw err;
  }
};

// get target countries
export const getTargetCountries = async () => {
  try {
    const response = await authFetch(
      `dream-destination`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error fetching countries:", err.message);
    throw err;
  }
};
// get target countries
export const getIntakes = async () => {
  try {
    const response = await authFetch(
      `intakes`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error fetching countries:", err.message);
    throw err;
  }
};

// get borad fileds
export const getbroadFileds = async () => {
  try {
    const response = await sapFetch(
      `get-broad-fields`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error fetching broad filelds:", err.message);
    throw err;
  }
};

// get narrow filds based on payload broad field
export const getNarrowFields = async (payload) => {
  try {
    const response = await sapFetch(
      `get-narrow-fields`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload), 
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error fetching narrow fields:", err.message);
    throw err;
  }
};

// save prefrences
export const savePrefrences = async (payload) => {
  try {
    const response = await authFetch(
      `profile/edit-preferences`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload), 
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error saving in prefrences:", err.message);
    throw err;
  }
};